import type { NuxtApp } from '#app'
import appConfig from '~/app.config'
import { useAccountStore } from '~/stores/account'
import authRequired from './auth-required.directive'

export default defineNuxtPlugin(nuxtApp => {
  type __NuxtApp = typeof nuxtApp &
    Pick<NuxtApp, '$router' | '$sdk' | '$snacks'>

  nuxtApp.vueApp.directive('auth-required', authRequired())

  const { $router, $sdk, $snacks } = nuxtApp as __NuxtApp

  const accountStore = useAccountStore()

  if (process.client) {
    $router.beforeEach(async (to, _from, next) => {
      if (appConfig.auth.callbackPath === to.path) {
        // 1) Telegram: /callback#tgAuthResult=...
        const hash = (location.hash || '').replace(/^#/, '')
        const hashParams = new URLSearchParams(hash)
        const tgAuthResult = hashParams.get('tgAuthResult')

        try {
          if (tgAuthResult) {
            const payload = tryParseTelegramPayload(tgAuthResult)
            if (payload) {
              const body = {
                origin: location.origin,
                event: 'auth_result',
                result: { ...payload }
              }
              const result = await $sdk
                .module('auth')
                .then(({ loginSocialComplete }) =>
                  loginSocialComplete(null, body)
                )

              if (result?.success && result?.redirect) {
                location.href = result.redirect
                return
              }

              // Ошибка телеграма — уводим на дефолт
              navigateToFallback()
              return
            } else {
              $snacks?.error?.('Ошибка привязки Telegram')
            }
          }

          // 2) Остальные провайдеры (Steam/Faceit): модуль сам прочитает location.search
          const result = await $sdk
            .module('auth')
            .then(({ loginSocialComplete }) => loginSocialComplete(null, {}))

          if (result?.success && result?.redirect) {
            location.href = result.redirect
            return
          }
        } catch {
          // ignore; упадём в фолбек
        }

        navigateToFallback()
        return
      }

      next()

      function tryParseTelegramPayload(raw: string) {
        const asJson = base64UrlToJson(raw)
        if (asJson && typeof asJson === 'object') return asJson

        if (raw.includes('.')) {
          const parts = raw.split('.')
          if (parts.length === 3) {
            const payload = base64UrlToJson(parts[1])
            if (payload && typeof payload === 'object') return payload
          }
        }
        return null
      }

      function base64UrlToJson(b64: string) {
        try {
          const decoded = atob(b64.replace(/-/g, '+').replace(/_/g, '/'))
          return JSON.parse(decoded)
        } catch {
          return null
        }
      }

      function navigateToFallback() {
        location.href =
          (nuxtApp as any).$normalizePath?.('/profile/settings/task/') ??
          '/profile/settings/task/'
      }
    })
  }

  return {
    provide: {
      auth: {
        get account(): any {
          return accountStore.account
        }
      }
    }
  }
})
